<svg viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    [attr.stroke]="colors()[0]"
    d="M51.4963 27.4276C51.4151 32.076 50.013 36.6054 47.4538 40.4868"
    [attr.stroke-width]="strokeWidth()"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    [attr.stroke]="colors()[1]"
    d="M42.0837 46.3063C38.4201 49.1686 34.0177 50.9294 29.3908 51.3831"
    [attr.stroke-width]="strokeWidth()"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    [attr.stroke]="colors()[2]"
    d="M21.4887 50.8721C16.9587 49.8262 12.8198 47.5131 9.55535 44.2027"
    [attr.stroke-width]="strokeWidth()"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    [attr.stroke]="colors()[3]"
    d="M4.97955 37.7401C2.94149 33.5615 2.13445 28.8892 2.65269 24.269"
    [attr.stroke-width]="strokeWidth()"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    [attr.stroke]="colors()[4]"
    d="M4.79546 16.6459C6.76028 12.4323 9.88342 8.86475 13.8001 6.35992"
    [attr.stroke-width]="strokeWidth()"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    [attr.stroke]="colors()[5]"
    d="M21.7857 3.06131C26.3283 2.07183 31.0587 2.3953 35.4244 3.99393"
    [attr.stroke-width]="strokeWidth()"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    [attr.stroke]="colors()[6]"
    d="M42.4157 7.95781C46.0292 10.8831 48.7358 14.7762 50.2193 19.1823"
    [attr.stroke-width]="strokeWidth()"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
